export default [
    function () {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: {
                message: '=eeeMessage',
            },
            controllerAs: 'ctrl',
            controller: [function () {
                    this.$onInit = function () {
                        const voip = this.message.voip;
                        const incoming = !this.message.isOutbox;
                        switch (voip.status) {
                            case 1:
                                this.colorClass = 'color-status-error';
                                this.icon = 'call_missed';
                                this.msgString = 'voip.CALL_MISSED';
                                break;
                            case 2:
                                this.colorClass = 'color-status-ok';
                                if (incoming) {
                                    this.icon = 'call_received';
                                    this.msgString = 'voip.CALL_FINISHED_IN';
                                }
                                else {
                                    this.icon = 'call_made';
                                    this.msgString = 'voip.CALL_FINISHED_OUT';
                                }
                                break;
                            case 3:
                                if (incoming) {
                                    this.icon = 'call_missed';
                                    switch (voip.reason) {
                                        case 1:
                                            this.colorClass = 'color-status-error';
                                            this.msgString = 'voip.CALL_MISSED_BUSY';
                                            break;
                                        case 3:
                                            this.colorClass = 'color-status-warning';
                                            this.msgString = 'voip.CALL_REJECTED';
                                            break;
                                        case 0:
                                        case 2:
                                        case 4:
                                        default:
                                            this.colorClass = 'color-status-error';
                                            this.msgString = 'voip.CALL_MISSED';
                                            break;
                                    }
                                }
                                else {
                                    this.icon = 'call_missed_outgoing';
                                    this.colorClass = 'color-status-error';
                                    switch (voip.reason) {
                                        case 1:
                                            this.msgString = 'voip.CALL_REJECTED_BUSY';
                                            break;
                                        case 2:
                                            this.msgString = 'voip.CALL_REJECTED_UNAVAILABLE';
                                            break;
                                        case 4:
                                            this.msgString = 'voip.CALL_REJECTED_DISABLED';
                                            break;
                                        case 3:
                                        case 0:
                                        default:
                                            this.msgString = 'voip.CALL_REJECTED';
                                            break;
                                    }
                                }
                                break;
                            case 4:
                                this.colorClass = 'color-status-warning';
                                this.icon = 'call_missed_outgoing';
                                this.msgString = 'voip.CALL_ABORTED';
                                break;
                        }
                    };
                }],
            template: `
                 <p>
                    <md-icon class="material-icons {{ ctrl.colorClass }}">{{ ctrl.icon }}</md-icon>
                    <span translate>{{ ctrl.msgString }}</span>
                </p>
            `,
        };
    },
];
